<template>
    <div class="get-in-touch">
        <div class="container get-in-touch__container">
            <div class="get-in-touch__headings">
                <p class="get-in-touch__heading">Get in touch</p>
            </div>
            <div class="get-in-touch__sections">
                <a href="#live-chat" v-on:click.prevent="openLiveChat" class="get-in-touch__section">
                    <svg class="get-in-touch__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.5 86.5">
                        <use href="#svg-live-chat-icon" />
                    </svg>

                    <div>
                        <p class="get-in-touch__title">Live chat</p>
                        <p class="get-in-touch__description">Start a conversation</p>
                    </div>
                </a>
                <a href="/contact-us" class="get-in-touch__section">
                    <img class="get-in-touch__icon" src="/images/used/enquiry-icon@2x.png" alt="">

                    <div>
                        <p class="get-in-touch__title">Contact us</p>
                        <p class="get-in-touch__description">Send an enquiry</p>
                    </div>
                </a>
                <a href="/dealer-locator" class="get-in-touch__section">
                    <svg class="get-in-touch__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.5 86.5">
                        <use href="#svg-location-icon" />
                    </svg>

                    <div>
                        <p class="get-in-touch__title">Find a dealer</p>
                        <p class="get-in-touch__description">Visit a dealership near you</p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        openLiveChat() {
            window.liveChatClass.startChat();
        }
    }
}
</script>

<style lang="scss">
@import '../../../../sass/redesign/variables';


.get-in-touch {
    background-color: $rd-pop-blue;
    color: white;
    padding-top: 55px;
    padding-bottom: 55px;
    margin-bottom: 30px;

    @media (min-width: $screen-sm) {
        padding-bottom: 65px;
    }

    &__headings {
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        @media (min-width: $screen-sm) {
            align-items: center;
            flex-direction: row;
        }
    }

    &__heading {
        font-weight: bold;
        font-size: 18px;
        margin: 0;
    }

    &__sections {
        display: flex;
        justify-content: space-evenly;
        margin-top: 24px;
        flex-direction: column;
        gap: 10px;

        @media (min-width: $screen-sm) {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            border-left: 1px solid white;
            gap: 0;
            margin-top: 42px;
        }
    }

    &__section {
        display: grid;
        grid-template-columns: 86px 1fr; 
        justify-content: left;
        align-items: center;
        color: inherit;
        gap: 20px;

        @media (min-width: $screen-sm) {
            margin-left: 32px;
            padding-right: 32px;
            border-right: 1px solid white;
        }

        &:hover {
            text-decoration: none;
        }
    }

    &__icon {
        width: 86px;
        height: 86px;
    }

    &__title {
        font-weight: bold;
        margin: 0;
    }

    &__description {
        margin: 0;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedLanding/GetInTouch.vue